export const trim = (string: string, length: number) => {
  if (string && string.length > length) {
    const trimmed = string.substring(0, length);
    
    return `${trimmed}...`;
  }
  return string;
};
